import React from 'react';
import MDKPIApproval from './MD_KPI_Approval';
import '../../../CommonCSS/SocietyCSS.css'

const MD_KPI_ApprApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Director's Monthly KPI Approval</h5>
          </div>
        </div>
        <MDKPIApproval/>
      </div>
    </div >
  );
};

export default MD_KPI_ApprApp;
